/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bi_Dashboard_Authoring_Restrict_DescriptionInputs */



/**
* | output |
* | --- |
* | "Only organization admins may create, edit, or delete BI dashboards. Viewing and refreshing existing dashboards stays available to everyone." |
*
* @param {Bi_Dashboard_Authoring_Restrict_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bi_dashboard_authoring_restrict_description = /** @type {((inputs?: Bi_Dashboard_Authoring_Restrict_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bi_Dashboard_Authoring_Restrict_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur Organisations-Admins dürfen BI-Dashboards erstellen, bearbeiten oder löschen. Das Ansehen und Aktualisieren bestehender Dashboards bleibt für alle möglich.")
	return /** @type {LocalizedString} */ ("Only organization admins may create, edit, or delete BI dashboards. Viewing and refreshing existing dashboards stays available to everyone.")
});